module.exports = __webpack_public_path__ + "img/image1.c342cc21.jpg";